var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-btn"},[_c('div',{staticClass:"btn",style:({backgroundImage: _vm.formatImg(_vm.imgUrl)}),on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }